import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArcStack, ArcText } from '@src/core/ui';
import { routesConfig } from '@src/core/routes';

const ForgotPasswordLink: React.FC = () => {
  const navigate = useNavigate();

  return (
    <ArcStack alignItems='flex-end'>
      <ArcText.caption
        color='brand'
        onClick={() => navigate(routesConfig.verifyEmail)}
        sx={{ textDecoration: 'underline', cursor: 'pointer' }}>
        Forgot Password?
      </ArcText.caption>
    </ArcStack>
  );
};

export default ForgotPasswordLink;

